import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-close-popup',
  templateUrl: './close-popup.component.html',
  styleUrls: ['./close-popup.component.css']
})
export class ClosePopupComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    // Send a message to the parent
    var sendMessage = function (msg) {
      // Make sure you are sending a string, and to stringify JSON
      window.parent.postMessage(msg, '*');
    };
    sendMessage('close_popup');
  }

  bindEvent(element, eventName, eventHandler) {
    if (element.addEventListener) {
      element.addEventListener(eventName, eventHandler, false);
    } else if (element.attachEvent) {
      element.attachEvent('on' + eventName, eventHandler);
    }
  }
}
